const displayFormater = new Intl.DisplayNames(
  import.meta.client ? (navigator.language ?? "nb") : "nb",
  { type: "language" },
)

export function toDisplayLanguage(code: string) {
  const name = displayFormater.of(code) ?? code
  return name.charAt(0).toUpperCase() + name.slice(1)
}
